<template>
  <!-- Modal -->
  <modal
    name="contact"
    :height="`100%`"
    :width="`100%`"
    :maxWidth="563"
    :adaptive="true"
  >
    <div class="flex flex-col modal-container">
      <button @click="$modal.hide('contact')" class="close-btn">
        <svg viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.707.793a1 1 0 0 0-1.414 0L5 4.086 1.707.793A1 1 0 0 0 .293 2.207L3.586 5.5.293 8.793a1 1 0 1 0 1.414 1.414L5 6.914l3.293 3.293a1 1 0 0 0 1.414-1.414L6.414 5.5l3.293-3.293a1 1 0 0 0 0-1.414z"
            fill="#000646"
          />
        </svg>
      </button>
      <div>
        <h4 class="mb-3">{{ heading }}</h4>
        <p v-html="content" />
      </div>

      <div class="form-container w-full">
        <form
          v-if="!isSubmitted"
          class="mt-8"
          action="#"
          @submit.prevent="submitForm"
        >
          <div class="flex flex-wrap -ml-5 -mb-5">
            <div
              v-for="field in fields.form.slice(0, 2)"
              :key="field.label"
              class="md:w-1/2 w-full pl-5 pb-5"
            >
              <label>
                <input
                  :type="field.type"
                  v-model="field.value"
                  :placeholder="field.label"
                  required
                />
              </label>
            </div>
            <div class="w-full pl-5 pb-6">
              <label>
                <input
                  :type="fields.form[2].type"
                  :placeholder="fields.form[2].label"
                  v-model="fields.form[2].value"
                  required
                />
              </label>
            </div>
            <div
              class="w-full pl-5 pb-2 flex flex-col justify-center items-center"
            >
              <button
                class="c-btn c-btn--accent"
                type="submit"
                :disabled="isSubmitted && isSubmitting"
              >
                {{ $root.globalOptions.get_started_button || 'Get Started' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    isSubmitted: false,
    isSubmitting: false,
  }),
  computed: {
    postFields() {
      return {
        firstName: this.fields.form[0].value,
        lastName: this.fields.form[1].value,
        email: this.fields.form[2].value,
        country: this.$root.countries.selected,
        language: this.$root.language,
        raising: this.$root.raising,
        nextRound: this.$root.nextRound,
        discount: this.$root.discount,
        cap: this.$root.cap,
        floor: this.$root.floor,
        low: this.$root.low,
        valuation: this.$root.valuation,
      };
    },
    fields() {
      return this.$root.modalFields;
    },
    heading() {
      return this.isSubmitted
        ? this.fields.confirmation.heading
        : this.fields.heading;
    },
    content() {
      return this.isSubmitted
        ? this.fields.confirmation.content
        : this.fields.content;
    },
  },
  methods: {
    async submitForm() {
      if (this.isSubmitting || this.isSubmitted) return false;
      this.isSubmitting = true;
      console.log(this.postFields);
      try {
        // Send a POST request
        const { data } = await axios({
          method: 'post',
          url: 'https://hooks.zapier.com/hooks/catch/6743973/ogbkb70/',
          transformRequest: [
            function(data, headers) {
              delete headers.post['Content-Type'];
              return data;
            },
          ],
          data: JSON.stringify(this.postFields),
        });

        this.isSubmitting = false;
        this.isSubmitted = data.status === 'success';
      } catch (error) {
        console.log(error);
        this.isSubmitting = false;
      }

      // isSubmitted = true;
    },
  },
};
</script>

<style lang="scss">
::placeholder {
  color: #000646 !important;
  opacity: 0.9 !important;
}

[data-modal='contact'] {
  form {
    label {
      display: block;
    }
    input {
      font-size: 20px;
      font-weight: 500;
    }
    .c-btn--accent {
      font-size: 20px;
      padding: 12px 33px 14px 33px;
    }
  }

  h4 {
    font-size: 30px;
    font-weight: 600;
  }
  p {
    font-size: 20px;
  }

  .v--modal-box {
    background: transparent;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .modal-container {
      position: relative;
      background: #fff;
      min-height: 266px;
      padding: 54px 1rem;
      width: 100%;
    }

    .close-btn {
      position: absolute;
      top: 26px;
      right: 28px;
      height: 14px;
      width: 14px;
    }

    > .flex {
      > * {
        max-width: 500px;
        @apply mx-auto;
      }
    }
  }
}
</style>
